import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';
import QuoteForm from '../components/QuoteForm';
import { getQuoteFaqItems, getQuoteProjectTypes } from '../data/quoteFaq';
import './QuotePage.css';

function QuotePage({ locale = 'fr', withTrailingSlash = true }) {
  const { t } = useTranslation();
  const canonical = locale === 'en' ? '/en/quote/' : '/devis/';

  if (!withTrailingSlash) {
    return <Navigate to={canonical} replace />;
  }

  const faqItems = getQuoteFaqItems(locale);
  const projectTypes = getQuoteProjectTypes(locale);

  return (
    <>
      <SEO
        locale={locale}
        title={t('quotePage.seoTitle')}
        description={t('quotePage.seoDescription')}
        canonical={canonical}
      />
      <StructuredData
        page="devis"
        locale={locale}
        contentPage={{ path: canonical, title: t('quotePage.seoTitle') }}
        faqItems={faqItems}
      />
      <main className="quote-page" id="main-content">
        <div className="quote-hero">
          <div className="container">
            <h1 className="quote-hero-title">{t('quotePage.h1')}</h1>
            <p className="quote-hero-subtitle">{t('quotePage.seoDescription')}</p>
          </div>
        </div>

        <section className="quote-intro section">
          <div className="container">
            <div className="quote-intro-content">
              <h2 className="quote-intro-title">{t('quotePage.introTitle')}</h2>
              <ul className="quote-project-types">
                {projectTypes.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </div>
          </div>
        </section>

        <QuoteForm locale={locale} />

        <section className="quote-faq section" aria-labelledby="quote-faq-title">
          <div className="container">
            <div className="section-header">
              <h2 id="quote-faq-title" className="section-title">
                {t('quotePage.faqTitle')}
              </h2>
            </div>
            <div className="quote-faq-list">
              {faqItems.map((item) => (
                <details key={item.question} className="quote-faq-item">
                  <summary className="quote-faq-question">{item.question}</summary>
                  <p className="quote-faq-answer">{item.answer}</p>
                </details>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default QuotePage;
